import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";

import FilterOperatorAction from "@app/types/FilterOperatorAction";

const filterOperatorsForListAndForecast: FilterOperatorAction = (field, defaultOperators) =>
  field.hasFeature(FieldFeature.FUNNEL_FIELD)
    ? defaultOperators.filter(({ operator }) => operator !== FilterOperator.EQUALS)
    : defaultOperators;

export default filterOperatorsForListAndForecast;
